<div class="content-body dashboard-page">

    <!-- Eltech admin view -->
    <ng-container *ngIf="isAuthorizedAdmin; else simpleDashboard">
        <h4 class="page-header">Australia Overview</h4>

        <p-tabView>


            <p-tabPanel header="Pending Approval">
                <div class="card">
                    <div class="no-requests" *ngIf="pendingUsers.length === 0">
                        <h3>No pending signup requests!</h3>
                        <img src="assets/img/no_data.webp" class="no-data-img">
                    </div>

                    <div *ngIf="pendingUsers.length !== 0">
                        <p-table [value]="pendingUsers" styleClass="p-datatable-striped"
                            [tableStyle]="{'min-width': '50rem'}">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Requested Date</th>
                                    <th>Organization</th>
                                    <th>Contact Person</th>
                                    <th>Email</th>
                                    <th>Country</th>
                                    <th>Action</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-user>
                                <tr>
                                    <td>{{user.requestedDate | date}}</td>
                                    <td [title]="user.organizationName">{{user.organizationName | truncate: 25}}</td>
                                    <td>{{user.name}}</td>
                                    <td>{{user.email}}</td>
                                    <td>{{user.country}}</td>
                                    <td>
                                        <button class="approve-btn" (click)="approve(user)">Approve</button>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </p-tabPanel>

            <p-tabPanel header="Current Users">
                <div class="card">
                    <div class="no-requests" *ngIf="currentUsers.length === 0">
                        <h3>No current users found!</h3>
                        <img src="assets/img/no_data.webp" class="no-data-img">
                    </div>

                    <div *ngIf="currentUsers.length !== 0">
                        <p-table [value]="currentUsers" styleClass="p-datatable-striped"
                            [tableStyle]="{'min-width': '50rem'}">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Organization</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Type</th>
                                    <th>Status</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-user>
                                <tr>
                                    <td [title]="user.organizationName">{{user.organizationName | truncate: 25}}</td>
                                    <td>{{user.name}}</td>
                                    <td>{{user.email}}</td>
                                    <td>{{user.userType}}</td>
                                    <td>{{user.status | uppercase}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
            </p-tabPanel>
            <p-tabPanel header="My Dashboard">
                <ng-container *ngTemplateOutlet="simpleDashboard"></ng-container>
            </p-tabPanel>
        </p-tabView>
    </ng-container>

    <!-- Everyone else (and reused as admin's "My Dashboard" tab) -->
    <ng-template #simpleDashboard>
        <h4 class="page-header" *ngIf="!isAuthorizedAdmin">My Dashboard</h4>

        <div class="card">
            <div class="dashboard-toolbar">
                <div class="dashboard-summary">
                    <div class="summary-box">
                        <span class="summary-count">{{totalProjects}}</span>
                        <span class="summary-label">Total Projects</span>
                    </div>
                </div>

                <div class="year-filter" *ngIf="yearOptions.length > 1">
                    <label>Year</label>
                    <p-dropdown [options]="yearOptions" optionLabel="label" optionValue="value"
                        [(ngModel)]="selectedYear" (onChange)="onYearChange()" styleClass="year-filter-dropdown">
                    </p-dropdown>
                </div>
            </div>
        </div>

        <div class="chart-row" *ngIf="filteredProjects.length !== 0">
            <div class="card chart-card">
                <h5>Projects by Installation Type</h5>
                <p-chart type="doughnut" [data]="installationTypeChartData" [options]="chartOptions"></p-chart>
            </div>

            <div class="card chart-card">
                <h5>Projects Created by Month</h5>
                <p-chart type="bar" [data]="monthlyChartData" [options]="chartOptions"></p-chart>
            </div>
        </div>

        <div class="card">
            <div *ngIf="filteredProjects.length !== 0">
                <p-table [value]="filteredProjects" styleClass="p-datatable-striped"
                    [tableStyle]="{'min-width': '50rem'}">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 15%;">Date</th>
                            <th style="width: 15%;">Project No</th>
                            <th style="width: 30%;">Project Name</th>
                            <th style="width: 25%;">Installation Type</th>
                            <th style="width: 15%;">Action</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-project>
                        <tr>
                            <td style="text-align: center;">{{project.CREATED_DATE}}</td>
                            <td style="text-align: center;">{{project.PROJECT_ID}}</td>
                            <td style="text-align: center;">{{project.PROJECT_NAME}}</td>
                            <td style="text-align: center;">{{project.INSTALLATION_TYPE}}</td>
                            <td style="text-align: center;">
                                <button class="view-project-btn" (click)="viewProject(project)">View Project</button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <div class="no-projects" *ngIf="filteredProjects.length === 0">
                <h3>No Projects found!</h3>
                <img src="assets/img/no_data.webp" class="no-data-img">
            </div>
        </div>
    </ng-template>

    <div class="kiktemp-loader" *ngIf="isGettingData">
        <img src="assets/img/kikblox_logo_rounded.webp" class="spinner" />
        <div class="loading-text">Loading...</div>
    </div>
</div>